export default __webpack_public_path__ + "static/media/logout.1567be1b.svg";